import { Button } from '@components/primitives/Button.js'
import { Modal } from '@components/primitives/Modal.js'
import { formatCurrency, formatDate } from '@utils/format.js'
import { useDocumentPreviewUrl } from '@hooks/useDocumentPreviewUrl.js'
import type { DocItem } from './types.js'
import { formatBytes, getFileIcon, isImage, isPdf } from './utils.js'

type Props = {
  doc: DocItem | null
  onClose: () => void
}

export function PreviewModal({ doc, onClose }: Props) {
  const previewUrl = useDocumentPreviewUrl(doc)
  const hasFile = Boolean(doc?.hasArquivo)

  if (!doc) return null

  return (
    <Modal
      open
      title={doc.nome}
      size='lg'
      onClose={onClose}
      actions={
        <div className='cf3-modal-actions'>
          <Button variant='ghost' onClick={onClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <div className='cf3-doc-preview'>
        {previewUrl && isImage(doc.tipo) ? (
          <img src={previewUrl} alt={doc.nome} className='cf3-doc-preview__img' />
        ) : previewUrl && isPdf(doc.tipo) ? (
          <iframe src={previewUrl} title={doc.nome} className='cf3-doc-preview__pdf' />
        ) : hasFile ? (
          <div className='cf3-doc-preview__unsupported'>
            <span aria-hidden className='cf3-doc-preview__icon'>
              {getFileIcon(doc.tipo)}
            </span>
            <p>Preview não disponível para este tipo de arquivo.</p>
            <p className='cf-text-muted'>
              Use o gerenciador de arquivos do dispositivo para abrir o documento.
            </p>
          </div>
        ) : (
          <div className='cf3-doc-preview__unsupported'>
            <span aria-hidden className='cf3-doc-preview__icon'>
              {getFileIcon(doc.tipo)}
            </span>
            <p>Arquivo não armazenado localmente.</p>
            <p className='cf-text-muted'>Importe o arquivo novamente para visualizá-lo.</p>
          </div>
        )}

        <div className='cf3-doc-preview__meta'>
          {doc.categoria && <span className='cf3-doc-preview__chip'>{doc.categoria}</span>}
          {doc.data && <span className='cf3-doc-preview__chip'>Data: {formatDate(doc.data)}</span>}
          {doc.fornecedor && (
            <span className='cf3-doc-preview__chip'>Fornecedor: {doc.fornecedor}</span>
          )}
          {doc.valor != null && (
            <span className='cf3-doc-preview__chip'>Valor: {formatCurrency(doc.valor)}</span>
          )}
          {doc.tamanho != null && doc.tamanho > 0 && (
            <span className='cf3-doc-preview__chip'>Tamanho: {formatBytes(doc.tamanho)}</span>
          )}
        </div>

        {doc.observacoes && <p className='cf3-doc-preview__obs'>{doc.observacoes}</p>}
      </div>
    </Modal>
  )
}
